import { render, staticRenderFns } from "./letture_filtri.vue?vue&type=template&id=3f25e5ce"
import script from "./letture_filtri.vue?vue&type=script&lang=js"
export * from "./letture_filtri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports